module.exports = __webpack_public_path__ + "static/img/说明2-1-沙具选择与放置.517f911.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mengceng/说明2-1-沙具选择与放置.png
// module id = ue8V
// module chunks = 1